/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".opciones[_ngcontent-%COMP%] {\r\n    text-align: center;\r\n}\r\n\r\n.banner[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{\r\n    margin-top: 10px;\r\n    background-color: yellow;\r\n    font-weight: 700;\r\n    border-radius: 20px;\r\n    padding: 20px;\r\n}"];
export { styles as styles };
